export default __webpack_public_path__ + "static/media/Avatar.3c6cd594.svg";